import Report from '../Common/Report'

function Endorsement() {
  return <Report isRenewal={false} />
}

export default Endorsement